import * as types from './actionTypes';  
import updateRequestedAmountApi from '../api/updateRequestedAmountApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doUpdateReqAmount(request) {

  return {
    type: types.DO_UPDATE_REQUESTED_AMOUNT, 
    request
  };
}

export function doUpdateReqAmountRes(data) {  
  return {
    type: types.DO_UPDATE_REQUESTED_AMOUNT_RES, 
    data
  };
}

export function sendUpdateReqAmount(request) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      updateRequestedAmountApi.doUpdateReqAmount(request).then(data => {
        dispatch(doUpdateReqAmountRes(data));
        dispatch(doUpdateReqAmountRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}

